import { Group, Select } from '@mantine/core'
import { useIntl } from 'react-intl'
import { Paginator } from 'primereact/paginator'
import { Dropdown } from 'primereact/dropdown'

import {
  getDataCountDisplayPerPage,
  getRowsPerPage,
} from '../../utils/helpers/common.js'

const AppLegacyPaginator = ({
  firstRow,
  limit,
  onPageChange,
  totalRecords,
  rowsPerPageInitial,
  rowsPerPageOptions,
  allowTotalRecords = false,
}) => {
  const { formatMessage: msg } = useIntl()

  const pagesTemplate = (options) => {
    const first = options.first + 1
    const last =
      options.first + options.rows > options.totalRecords
        ? options.totalRecords
        : options.first + options.rows
    const totalRs = options.totalRecords
    return (
      <span className="power">
        <span>
          {first} - {last}
        </span>
        <span>{' / '}</span>
        <span>{totalRs}</span>
      </span>
    )
  }

  const dropdownRowPerPage = (options) => {
    const stdRowPage = 15
    const maxRowPage = 100
    // const rowPerPageOptionsDefault = [100]

    const rowsPerPageOptionsDefault = [
      { label: 15, value: 15 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
      // { label: !allowTotalRecords && options.totalRecords > maxRowPage
      //     ? msg({id: 'max'}).concat(": ").concat(maxRowPage)
      //     : msg({id: 'all'}).concat(": ").concat(options.totalRecords),
      // value: !allowTotalRecords && options?.totalRecords > maxRowPage
      //     ? maxRowPage
      //     : options.totalRecords
      // }
    ]
    // .filter((row) => row.value <= options.totalRecords)
    return (
      <Dropdown
        value={options?.value}
        defaultValue={rowsPerPageOptionsDefault[0].value}
        style={{ minWidth: '60px' }}
        options={rowsPerPageOptionsDefault}
        onChange={options.onChange}
      />
      // options={options?.value === 100 ? rowPerPageOptionsDefault : rowPerPageOptions} onChange={options.onChange} />
    )
  }

  const template = {
    layout:
      'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
    RowsPerPageDropdown: (options) => dropdownRowPerPage(options),
  }

  return (
    <Group w="100%" h={50} justify="center" wrap="nowrap">
      {totalRecords > 0 ? (
        <Paginator
          first={firstRow || 0} // Zero-relative number of the first row to be displayed
          rows={
            rowsPerPageOptions === 100
              ? 100
              : getDataCountDisplayPerPage({ limit, rowsPerPageOptions })
          }
          totalRecords={totalRecords || 0} //Number of total records.
          template={template}
          rowsPerPageOptions={
            rowsPerPageOptions || getRowsPerPage(rowsPerPageInitial)
          }
          onPageChange={onPageChange} //Callback to invoke when page changes, the event object contains information about the new state.
          rightContent={pagesTemplate}
          currentPageReportTemplate="{first} - {last} / {totalRecords}"
          pt={{
            pageButton: ({ context }) => ({
              className: context.active ? 'page-active' : undefined,
            }),
          }}
        />
      ) : (
        ''
      )}
    </Group>
  )
}

export default AppLegacyPaginator
